// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_6VKcc){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_33M-5 .dualColumn_dxXXi{display:flex;align-content:space-between}.nsAddressForm_33M-5 .dualColumn_dxXXi .firstCol_1Bx2v{margin-right:20px}.optional_3uTzx{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_6VKcc",
	"nsAddressForm": "nsAddressForm_33M-5",
	"dualColumn": "dualColumn_dxXXi",
	"firstCol": "firstCol_1Bx2v",
	"optional": "optional_3uTzx"
};
module.exports = exports;
